import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../../stores/authStore";
import { toastService } from "../../../providers";

export function usePinChallenge() {
  const navigate = useNavigate();
  const {
    setTokens,
    pinChallengeId,
    pinChallengeExpiresAt,
    clearPinChallenge,
  } = useAuthStore();

  const [secondsLeft, setSecondsLeft] = useState(() =>
    pinChallengeExpiresAt
      ? Math.max(
          0,
          Math.floor(
            (new Date(pinChallengeExpiresAt).getTime() - Date.now()) / 1000,
          ),
        )
      : 0,
  );

  const redirectToLogin = (bannerReason) => {
    clearPinChallenge();
    navigate(
      "/auth/login",
      bannerReason ? { state: { bannerReason } } : undefined,
    );
  };

  useEffect(() => {
    if (!pinChallengeId) {
      navigate("/auth/login", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!pinChallengeExpiresAt) return undefined;
    const expiresAtMs = new Date(pinChallengeExpiresAt).getTime();

    const tick = () => {
      const remaining = Math.max(
        0,
        Math.floor((expiresAtMs - Date.now()) / 1000),
      );
      setSecondsLeft(remaining);
      if (remaining === 0) {
        redirectToLogin("pin_challenge_expired");
      }
    };

    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pinChallengeExpiresAt]);

  const completeLogin = (data, successMessage) => {
    setTokens(data.accessToken, data.refreshToken);
    clearPinChallenge();
    toastService.success(successMessage);
    navigate("/dashboard");
  };

  return {
    pinChallengeId,
    secondsLeft,
    redirectToLogin,
    completeLogin,
    navigate,
  };
}
